import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from './http-data.service';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class RankingService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/leaderboards');
  }
  fetch(options?: any): Promise<any> {
    if (!options.clientId) {
      return;
    }
    const clientId = options.clientId;
    delete options.clientId;
    return lastValueFrom(
      this.http.get(`${this.baseUrl}/clients/${clientId}`, {
        ...this.getRequestOptions(options),
        observe: 'response'
      })
    )
      .then((response: any) => {
        switch (response.status) {
          case 200:
          case 201:
          case 202:
          case 203:
            return response.body;
          default:
            return false;
        }
      })
      .catch((error) => this.handleObservableError(error));
  }
}
